import {
  getApiV1ThreeLetterCodePartnerAdminsGroupsId,
  getGetApiV1ThreeLetterCodePartnerAdminsGroupsIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsGroupsId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** グループID */
  id: number;
};

type ReturnType = {
  /** グループデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsGroupsId200;
};

/**
 * useGetPartnerAdminsGroupフックの型定義
 */
type IUseGetPartnerAdminsGroup = (args: Args) => ReturnType;

/**
 * パートナー管理者用グループ詳細取得フック
 */
export const useGetPartnerAdminsGroup: IUseGetPartnerAdminsGroup = ({ threeLetterCode, id }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsGroupsIdKey(threeLetterCode, id),
    () => getApiV1ThreeLetterCodePartnerAdminsGroupsId(threeLetterCode, id),
    { suspense: true }
  );

  return {
    data,
  };
};
